import { Outlet, useLocation } from "react-router";
import "./Notifications.scss";

/**
 * Notifications page shell — page header and the active sub-route outlet.
 * The body is delegated to nested route components (e.g. Outbox, TestEmailTemplate).
 * @returns {import('react').JSX.Element}
 */
const Notifications = () => {
    const { pathname } = useLocation();

    return (
        <div className="container notifications-page">
            <div className="notifications-page__intro">
                <p className="title">Notifications</p>
                <p className="sub-title">
                    {pathname.endsWith("/test-email-template")
                        ? "Send test email notifications based on available templates"
                        : "Notification templates and outbox"}
                </p>
            </div>

            <Outlet />
        </div>
    );
};

export default Notifications;
